/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices
{
    "use strict";

    export class DealerwareInternationalizationDateFormats {
        public static $inject: string[] = [
            '$dealerwareInternationalizationData', '$http'
        ];

        public labels: {};
        public availableTimes12hrs: any;
        public locales: {};
        public FR = 'fr';
        public FR_CA = 'fr-CA';
        public EN = 'en';

        constructor(public $dealerwareInternationalizationData: any, public $http: any) {
            this.getLabels('dateFormat');
        }

        public getLocales() {
            return this.$http({
            method: 'GET',
            url: `/samples/locales.json`
            });
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                        _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                        _self.setAvailableTime12();
                    },
                    function(error: any) {
                    }
                );
        }

        public defaultLang : string = 'en-US';
        public anyPatternDate : any = /^\d{1,4}([./-])\d{1,4}\1\d{1,4}$/;
        public anyPatternTime : any = /(\d{1,2}([.:])\d{2}) ((A|P)M)/;

        public formats: any = {
            'en': 'MM/DD/YYYY',
            'en-US': 'MM/DD/YYYY',
            'en-CA': 'YYYY-MM-DD',
            'fr-CA': 'YYYY-MM-DD',
            'fr': 'YYYY-MM-DD',
            'es-419': 'DD/MM/YYYY'
        }

        public formatsMonth: any = {
            'en': 'MM/YYYY',
            'en-US': 'MM/YYYY',
            'en-CA': 'YYYY-MM',
            'fr-CA': 'YYYY-MM',
            'fr': 'YYYY-MM'
        }

        public timeFormats: any = {
            'en': 'hh:mm A',
            'en-US': 'hh:mm A',
            'en-CA': 'hh:mm A',
            'fr-CA': 'HH:mm',
            'fr': 'HH:mm',
            'es-419': 'hh:mm A'
        }

        public formatPatternRegex: any = {
            'en': /^\d{1,2}([./-])\d{1,2}\1\d{4}$/,
            'en-US': /^\d{1,2}([./-])\d{1,2}\1\d{4}$/,
            'en-CA': /^\d{4}([.-])\d{1,2}\1\d{1,2}$/,
            'fr-CA': /^\d{4}([.-])\d{1,2}\1\d{1,2}$/,
            'fr': /^\d{4}([.-])\d{1,2}\1(0[1-9]|[12]\d|3[01])$/,
            'es-419': /^\d{1,2}([./-])\d{1,2}\1\d{4}$/
        }

        public languages24hrs: string[] = ['fr'];

        public availableTimes24hrs = [
            { display: '00:00', value: '00:00' },
            { display: '00:30', value: '00:30' },
            { display: '01:00', value: '01:00' },
            { display: '01:30', value: '01:30' },
            { display: '02:00', value: '02:00' },
            { display: '02:30', value: '02:30' },
            { display: '03:00', value: '03:00' },
            { display: '03:30', value: '03:30' },
            { display: '04:00', value: '04:00' },
            { display: '04:30', value: '04:30' },
            { display: '05:00', value: '05:00' },
            { display: '05:30', value: '05:30' },
            { display: '06:00', value: '06:00' },
            { display: '06:30', value: '06:30' },
            { display: '07:00', value: '07:00' },
            { display: '07:30', value: '07:30' },
            { display: '08:00', value: '08:00' },
            { display: '08:30', value: '08:30' },
            { display: '09:00', value: '09:00' },
            { display: '09:30', value: '09:30' },
            { display: '10:00', value: '10:00' },
            { display: '10:30', value: '10:30' },
            { display: '11:00', value: '11:00' },
            { display: '11:30', value: '11:30' },
            { display: '12:00', value: '12:00' },
            { display: '12:30', value: '12:30' },
            { display: '13:00', value: '13:00' },
            { display: '13:30', value: '13:30' },
            { display: '14:00', value: '14:00' },
            { display: '14:30', value: '14:30' },
            { display: '15:00', value: '15:00' },
            { display: '15:30', value: '15:30' },
            { display: '16:00', value: '16:00' },
            { display: '16:30', value: '16:30' },
            { display: '17:00', value: '17:00' },
            { display: '17:30', value: '17:30' },
            { display: '18:00', value: '18:00' },
            { display: '18:30', value: '18:30' },
            { display: '19:00', value: '19:00' },
            { display: '19:30', value: '19:30' },
            { display: '20:00', value: '20:00' },
            { display: '20:30', value: '20:30' },
            { display: '21:00', value: '21:00' },
            { display: '21:30', value: '21:30' },
            { display: '22:00', value: '22:00' },
            { display: '22:30', value: '22:30' },
            { display: '23:00', value: '23:00' },
            { display: '23:30', value: '23:30' }
        ];

        public setAvailableTime12() : void {
            this.availableTimes12hrs = [
                { display: this.labels.time.midnight, value: '00:00' },
                { display: '12:30 am', value: '00:30' },
                { display: '1:00 am',  value: '01:00' },
                { display: '1:30 am',  value: '01:30' },
                { display: '2:00 am',  value: '02:00' },
                { display: '2:30 am',  value: '02:30' },
                { display: '3:00 am',  value: '03:00' },
                { display: '3:30 am',  value: '03:30' },
                { display: '4:00 am',  value: '04:00' },
                { display: '4:30 am',  value: '04:30' },
                { display: '5:00 am',  value: '05:00' },
                { display: '5:30 am',  value: '05:30' },
                { display: '6:00 am',  value: '06:00' },
                { display: '6:30 am',  value: '06:30' },
                { display: '7:00 am',  value: '07:00' },
                { display: '7:30 am',  value: '07:30' },
                { display: '8:00 am',  value: '08:00' },
                { display: '8:30 am',  value: '08:30' },
                { display: '9:00 am',  value: '09:00' },
                { display: '9:30 am',  value: '09:30' },
                { display: '10:00 am', value: '10:00' },
                { display: '10:30 am', value: '10:30' },
                { display: '11:00 am', value: '11:00' },
                { display: '11:30 am', value: '11:30' },
                { display: this.labels.time.noon, value: '12:00' },
                { display: '12:30 pm', value: '12:30' },
                { display: '1:00 pm',  value: '13:00' },
                { display: '1:30 pm',  value: '13:30' },
                { display: '2:00 pm',  value: '14:00' },
                { display: '2:30 pm',  value: '14:30' },
                { display: '3:00 pm',  value: '15:00' },
                { display: '3:30 pm',  value: '15:30' },
                { display: '4:00 pm',  value: '16:00' },
                { display: '4:30 pm',  value: '16:30' },
                { display: '5:00 pm',  value: '17:00' },
                { display: '5:30 pm',  value: '17:30' },
                { display: '6:00 pm',  value: '18:00' },
                { display: '6:30 pm',  value: '18:30' },
                { display: '7:00 pm',  value: '19:00' },
                { display: '7:30 pm',  value: '19:30' },
                { display: '8:00 pm',  value: '20:00' },
                { display: '8:30 pm',  value: '20:30' },
                { display: '9:00 pm',  value: '21:00' },
                { display: '9:30 pm',  value: '21:30' },
                { display: '10:00 pm', value: '22:00' },
                { display: '10:30 pm', value: '22:30' },
                { display: '11:00 pm', value: '23:00' },
                { display: '11:30 pm', value: '23:30' }
            ];
        }

        public language() : string {
            return window.navigator.userLanguage || window.navigator.language;
        }

        public getFormat(defaultLang = null) : string {
            const selectLang = defaultLang || this.language();
            return this.formats[selectLang] ? this.formats[selectLang] : this.formats[this.defaultLang];
        }

        public getTimeFormat(defaultLang = null) : string {
            const selectLang = defaultLang || this.language();
            return this.timeFormats[selectLang] ? this.timeFormats[selectLang] : this.timeFormats[this.defaultLang];
        }

        public getAvailablesTimesFormat(defaultLang = null) : any {
            const selectLang = defaultLang || this.language();
            return selectLang.indexOf('fr') !== -1 ? this.availableTimes24hrs : this.availableTimes12hrs;
        }

        public datePickerFormat() : any {
            return {
                doFormat: (date) => {
                    return moment(date).format(this.getFormat());
                },
                formatDate: function(date) {
                    return this.doFormat(date);
                },
                parseDate: ( dateString: string ) => {
                    if (dateString) {
                        var m = moment(dateString, this.getFormat(), true);
                        return m.isValid() ? m.toDate() : new Date();
                    }
                    return null;
                }
            }
        }

        public parseDateForRequest(date, responseFormat, lastFormat = null) : any {
            if (!lastFormat) {
                let currentFormat = moment(date, this.getFormat()).format(responseFormat);
                if (Date.parse(currentFormat)) {
                    return currentFormat;
                }
            } else {
                let lastFormatParameter = moment(date, lastFormat).format(responseFormat);
                if (Date.parse(lastFormatParameter)) {
                    return lastFormat;
                }
            }

            return moment(date).format(responseFormat);
        }

        public parseDateToDisplayOnTheApplication(date, lastFormat = null) : any {
            if (lastFormat) {
                let currentDate = moment(date, lastFormat).format(this.getFormat());
                if (Date.parse(currentDate)) {
                    return currentDate;
                }
            }
            return moment(date).format(this.getFormat());
        }

        public dateFormatMatch(date, defaultLang = null) : boolean {
            var format = this.getFormat(defaultLang);
            var patternToValidate = this.formatPatternRegex[this.language()] || this.formatPatternRegex[this.defaultLang];
            if (date && Date.parse(date)) {
                var patternValidation = patternToValidate.test(date);
                return (moment(date, format).isValid() && ((date.length === format.length) || patternValidation));
            }
            return false;
        }
    }

    getDealerwareWebServicesModule().service(
        '$dealerwareInternationalizationDateFormats', DealerwareInternationalizationDateFormats
    );
}
